import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {useDispatch} from 'react-redux';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import ButtonAction from '../../../_common/components/ButtonAction';
import ModalContainer from '../../../_common/components/ModalContainer';
import {showGlobalMessage} from '../../../_common/components/GlobalMessage/actions/showGlobalMessage';
import {can} from '../../../_common/components/Permissions';
import {permissionTypes as T, subjects as S} from '../../../_common/constants/permissionSubjects';
import {deleteCustomer, restoreCustomer} from '../../actions/CustomersEntityTableActions';
import {tooltips as TTS} from '../../../_common/constants/tooltips';
import {messages as M} from '../../../../../_metronic/i18n/messages';
import ModalHeader from '../../../_common/components/ModalHeader';
import ModalButtonsContainer from '../../../_common/components/ModalButtonsContainer';
import {buttonCancel, buttonSubmit, largeButtonsPadding} from '../../../_common/styles/styles';

export default function PopupDeleteRestoreCustomer({data}) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const customerName = [data.firstName, data.lastName].filter(Boolean).join(' ');
  const isDeleted = data?.deleted ? data.deleted : false;
  const handleAction = async () => {
    const result = isDeleted
      ? await dispatch(restoreCustomer(data.customerID))
      : await dispatch(deleteCustomer(data.customerID));
    if (result.errorCode < 0) {
      await dispatch(showGlobalMessage('error', M['-1']));
    }
    handleCloseModal();
  };
  const prefix = 'customers-entity-popup';
  const icon = `media/common/${isDeleted ? 'Restore_green.svg' : 'Delete_red.svg'}`;
  const message = isDeleted
    ? (
      <FormattedMessage
        id={`${prefix}-restore-header`}
        defaultMessage="Are you sure you want to restore {name}?"
        values={{name: customerName}}
      />
    )
    : (
      <FormattedMessage
        id={`${prefix}-delete-header`}
        defaultMessage="Are you sure you want to delete {name}?"
        values={{name: customerName}}
      />
    );
  const tooltip = isDeleted ? TTS.RESTORE_CUSTOMER : TTS.DELETE_CUSTOMER;
  const buttonApprove = isDeleted
    ? <FormattedMessage id={`${prefix}-restore-yes`} defaultMessage="Restore"/>
    : <FormattedMessage id={`${prefix}-delete-yes`} defaultMessage="Delete"/>;

  return (
    <>
      <ButtonAction
        variant={'icon'}
        iconButtonType={isDeleted ? 'success' : 'error'}
        title={tooltip}
        disabled={!can(T.FULL, S.CUSTOMERS_ENTITY_PAGE)}
        onClick={handleShowModal}
        label={<img src={toAbsoluteUrl(icon)} alt="action"/>}
        customClassnames={'mx-2'}
      />
      <ModalContainer show={show} onHide={handleCloseModal} size={'md'}>
        <ModalHeader header={message}/>
        <ModalButtonsContainer customClassnames={largeButtonsPadding}>
          <ButtonAction
            variant={'cancel'}
            onClick={handleCloseModal}
            label={<FormattedMessage id={`${prefix}-delete-no`} defaultMessage="No"/>}
            customClassnames={buttonCancel}
          />
          <ButtonAction
            onClick={() => handleAction()}
            useIcon={'/media/common/Check-in-circle_white.svg'}
            label={buttonApprove}
            customClassnames={buttonSubmit}
          />
        </ModalButtonsContainer>
      </ModalContainer>
    </>
  );
}